/**
 * 악덕알리미 서비스 가입 동의 ($j.Pages.Devil.Agree / body data-page-name="Agree")
 *
 * 미가입자가 /b 진입 시 devilAuth 게이트로 도착. 필수 2개([필수]이용약관·개인정보처리방침)
 * 동의 후 [확인] → POST /b/join → 홈(/b)으로.
 */
export default class Agree {
    initialize() {
        this.agreed = { 1: false, 2: false };

        $('#ag-all').on('click', () => {
            const next = !(this.agreed[1] && this.agreed[2]);
            this.agreed[1] = next;
            this.agreed[2] = next;
            this.render();
        });
        $('.ag-item').on('click', (e) => {
            const i = $(e.currentTarget).data('ag');
            this.agreed[i] = !this.agreed[i];
            this.render();
        });
        // 약관 '보기' — 토글과 분리. Terms BS 모듈의 단일 약관 모달 재사용
        $('.ag-view').on('click', (e) => {
            e.preventDefault();
            $j.F.Devil.Terms.viewTerm($(e.currentTarget).data('code'));
        });
        $('#ag-ok').on('click', () => this.submit());

        this.render();
    }

    render() {
        const all = this.agreed[1] && this.agreed[2];
        // 체크박스 렌더 (전체동의 = 필수 모두 체크 상태)
        this._chk($('#ag-all .ag-chk'), all);
        this._chk($('.ag-item[data-ag="1"] .ag-chk'), this.agreed[1]);
        this._chk($('.ag-item[data-ag="2"] .ag-chk'), this.agreed[2]);

        const $ok = $('#ag-ok');
        $ok.prop('disabled', !all).toggleClass('is-on', all);   // 색은 _agree.scss
    }

    _chk($el, on) {
        $el.attr('data-on', on ? '1' : '0').html(this._box(on));
    }

    _box(on) {
        return on
            ? '<svg width="20" height="20" viewBox="0 0 20 20"><rect width="20" height="20" rx="3" fill="var(--R)"/><path d="M5 10l3.5 3.5L15 7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>'
            : '<svg width="20" height="20" viewBox="0 0 20 20"><rect x=".5" y=".5" width="19" height="19" rx="2.5" fill="none" stroke="var(--t3)" stroke-width="1.5"/></svg>';
    }

    submit() {
        if (!(this.agreed[1] && this.agreed[2])) return;
        const $ok = $('#ag-ok').prop('disabled', true).text('처리 중…');
        $.ajax({
            type: 'POST',
            url: '/b/join',
            dataType: 'json',
            success(data) {
                if (data && data.result) {
                    location.replace(data.redirect || '/b');
                } else {
                    alert((data && data.message) || '가입 처리에 실패했습니다.');
                    $ok.prop('disabled', false).text('확인');
                }
            },
            error() {
                alert('가입 처리 중 오류가 발생했습니다.');
                $ok.prop('disabled', false).text('확인');
            },
        });
    }
}
